<router-outlet />

<core-alert-container />

<core-loader imageUrl="/assets/images/logo_blanco.svg"/>